export default "__VITE_ASSET__C7EM_Ca4__"